// Lightweight AJAX handler for Shopify newsletter forms (footer scope)
// Submits the customer form via fetch and updates success/error messages without page reload

document.addEventListener('DOMContentLoaded', () => {
  const form = document.querySelector('footer .footer__newsletter-form');
  if (!form) return;

  const input = form.querySelector('.field__input');
  const button = form.querySelector('.newsletter-form__button');
  const errorEl = form.querySelector('[id^="FooterNewsletter-error--"]');
  const successEl = form.querySelector('[id^="FooterNewsletter-success--"]');

  const showError = (msg) => {
    if (errorEl) {
      const textNode = errorEl.querySelector('.newsletter-error-text');
      if (textNode) textNode.textContent = msg;
      errorEl.style.display = 'flex';
    }
    if (successEl) successEl.style.display = 'none';
    input?.setAttribute('aria-invalid', 'true');
  };

  const showSuccess = () => {
    if (successEl) successEl.style.display = 'block';
    if (errorEl) errorEl.style.display = 'none';
    input?.removeAttribute('aria-invalid');
    input && (input.value = '');
    successEl?.focus();
  };

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const email = (input?.value || '').trim();

    // Basic email validation before we hit the network
    const emailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    if (!emailValid) {
      showError('Bitte gültige E-Mail eingeben');
      return;
    }

    button?.setAttribute('disabled', 'disabled');
    try {
      const fd = new FormData(form);
      // Shopify's form tag adds form_type and utf8 automatically; FormData picks them up.
      const res = await fetch(form.action, {
        method: 'POST',
        body: fd,
        headers: {
          'Accept': 'text/html',
          'X-Requested-With': 'XMLHttpRequest'
        },
        redirect: 'follow'
      });

      if (res.ok) {
        // Treat any 200 as success for newsletter signup
        showSuccess();
      } else {
        showError('Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.');
      }
    } catch (err) {
      showError('Netzwerkfehler. Bitte versuchen Sie es erneut.');
    } finally {
      button?.removeAttribute('disabled');
    }
  });
});